// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__31szm","text":"SelectPayment_text__jfg0f","title":"SelectPayment_title__3rBaW","btn":"SelectPayment_btn__3uS3Q"};